import { useMemo } from 'react';

import { selectors, useAppSelector } from '@fhs-legacy/frontend/src/state/global-state';
import { useIsLoyaltyEnabled } from '@fhs-legacy/frontend/src/state/loyalty/hooks/use-is-loyalty-enabled';
import { useOffersContext } from '@fhs-legacy/frontend/src/state/offers';
import { IOfferDiscount } from '@rbi-ctg/menu';

import { useCartValues } from '../cart-store-values';
import { ILoyaltyInfo, isOfferDiscount } from '../loyalty-helpers';

import { computeCartTotal } from './compute-cart-total';

export default function useCartTotal() {
  const { selectedOffer, selectedOfferCartEntry, selectedOfferPrice } = useOffersContext();
  const { cartEntries } = useCartValues();
  const loyaltyEnabled = useIsLoyaltyEnabled();

  const discountAppliedCmsOffers = useAppSelector(selectors.loyalty.selectDiscountAppliedCmsOffer);
  const loyaltySelectedOffer = useAppSelector(selectors.loyalty.selectSelectedOffer);
  const appliedLoyaltyRewards = useAppSelector(selectors.loyalty.selectAppliedLoyaltyRewards);
  const offersEligibleItems = useAppSelector(selectors.loyalty.selectOffersEligibleItems);

  const total = useMemo(() => {
    if (!cartEntries.length) {
      return 0;
    }
    const offerDetails = {
      selectedOffer,
      selectedOfferCartEntry,
      selectedOfferPrice,
    };

    const loyaltyInfo: ILoyaltyInfo = {
      loyaltyEnabled,
      appliedLoyaltyRewards,
      appliedLoyaltyOfferDiscount: discountAppliedCmsOffers?.incentives?.find(
        incentive => !!incentive && isOfferDiscount(incentive)
      ) as IOfferDiscount,
      offersEligibleItems,
      loyaltySelectedOffer: loyaltySelectedOffer ?? undefined,
    };

    return computeCartTotal(offerDetails, cartEntries, loyaltyInfo);
  }, [
    selectedOffer,
    selectedOfferCartEntry,
    selectedOfferPrice,
    cartEntries,
    loyaltyEnabled,
    appliedLoyaltyRewards,
    discountAppliedCmsOffers,
    offersEligibleItems,
    loyaltySelectedOffer,
  ]);

  return total;
}
